export const featuredConnectorTargets = [
  // Social
  'google',
  'apple',
  'facebook',
  'github',
  'discord',
  'wechat',
  'alipay',
  'kakao',
  'naver',
  'azuread',
  // Email
  'aws-ses',
  'sendgrid-mail',
  'aliyun-dm',
  // SMS
  'twilio-sms',
  'aliyun-sms',
  'tencent-sms',
];
